export default __webpack_public_path__ + "static/media/new_ai_math.3ef84b9c.webp";